module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/scale-22af1671c9904761a349ba85e2c7879b.svg";